import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../themes/palette";
const useStyles = makeStyles((theme) => {
  return {
    mainProductContainer: {
      paddingLeft: theme.spacing(myTheme.padding.left + 3.4),
      paddingRight: theme.spacing(myTheme.padding.right + 3.4),
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        //marginLeft:'15%'
      },
    },
    bCrumbLink: {
      "text-decoration": "none",
      color: "grey",
      "&:hover": {
        color: "black",
        "text-decoration": "none",
      },
    },
    bcrumCurrentPageText:{
      maxWidth:500,
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        maxWidth:400
        //marginLeft:'15%'
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        maxWidth:320
        //marginLeft:'15%'
      }
    },
    mainProductImg: {
      height: 300,
      width: 300,
      objectFit: "scale-down",
      display: "block",
      margin: "auto auto",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        height: 220,
        marginBottom: 12,
      },
    },
    subcategoryImgBtn: {
      border: "0.2px solid #e1e1e1",
      backgroundColor: "#fff",
      border: "0.2px solid #e1e1e1",
      padding: 0,
      marginRight: 10,
      "&:hover": {
        border: "0.2px solid " + myTheme.palette.primary.main,
      },
    },
    subProductImg: {
      height: 66,
      width: 66,
      padding: 3,
      objectFit: "fill",
      display: "block",
      //paddingRight:2,
      //marginRight:9

      // [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
      //   height: 150,
      // },
    },
    productDescMainGrid: {
      backgroundColor: "#fff",
      padding: 5,
      display: "flex",
      justifyContent: "space-between",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        justifyContent: "center",
      },
    },
    subCategoryImgBoxGrid: {
      overflow: "auto",
      display: "flex",
      flexDirection: "row",
      "scroll-behavior": "smooth",
    },
    ratingBox: {
      display: "flex",
      marginTop: 13,
      textAlign: "center",
      flexDirection: "row",
      // '& > * + *': {
      //   marginTop: theme.spacing(1),
      // },
    },
    pricesBox: {
      paddingTop: 7,
      flexDirection: "column",
      // [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
      //   display:'flex',
      //   flexDirection:'column'
      // },
    },
    priceText: {
      color: myTheme.palette.primary.main,
      fontWeight: "bold",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        fontSize: 18,
      },
    },
    cutPriceText: {
      //marginLeft:16,
      textDecoration: "line-through",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        fontSize: 15,
        marginLeft: 1,
      },
    },
    colorPickerMainBox: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    colorBox: {
      border: "0.2px solid silver",
      "&:hover": {
        border: "0.2px solid " + myTheme.palette.primary.main,
      },
      marginLeft: 10,
    },
    addToCartBtn: {
      backgroundColor: myTheme.palette.primary.main,
      color: myTheme.palette.primary.contrastText,
      padding: 8,
      paddingLeft: 35,
      paddingRight: 35,
      "&:hover": {
        backgroundColor: myTheme.palette.primary.dark,
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        width: "100%",
      },
    },
    cartAndWishlistBtn: {
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        flexDirection: "column",
      },
    },
    specificationsBox: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      margin: "auto",
      justifyContent: "space-between",
      borderBottom: "0.2px solid #e9e9e9",
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        flexDirection: "column",
      },
    },
    specificationLastBox: {
      backgroundColor: "#fff",
      padding: 10,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        padding: 0,
      },
    },
    addToWishlistBtn: {
      backgroundColor: "#e9e9e9",
      color: "black",
      padding: 8,
      margin: "auto",
      paddingLeft: 35,
      paddingRight: 35,
      "&:hover": {
        backgroundColor: "#e3e3e3",
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        width: "100%",
        marginTop: 8,
      },
    },
    midSpecifcationsBox: {
      backgroundColor: "#fff",
      padding: 10,
      margin: "auto",
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        margin: 0,
        padding: 0,
      },
    },
    chatBtn: {
      color: myTheme.palette.primary.main,
      "&:hover": {
        backgroundColor: "none",
      },
    },
    goToStoreBtn: {
      backgroundColor: "#e9e9e9",
      color: myTheme.palette.secondary.main,
      "&:hover": {
        backgroundColor: myTheme.palette.primary.dark,
        color: myTheme.palette.primary.contrastText,
      },
      marginTop: 20,
      width: "100%",
    },
    numberedRatingsStarsBox: {
      display: "flex",
      flexDirection: "column",
      margin: "auto",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        margin: 0,
        marginTop: 14,
        display: "block",
      },
    },
    AvgRatingsBoxes: {
      display: "flex",
      flexDirection: "row",
      borderBottom: "0.2px solid #e9e9e9",
      paddingBottom: 30,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        flexDirection: "column",
      },
    },
    reviewVerificationAndTimeBox: {
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        display: "flex",
        flexDirection: "column",
      },
    },
    fromSameStoreBox: {
      backgroundColor: "#fff",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingTop: 15,
      paddingBottom: 20,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        visibility: "hidden",
        display: "none",
      },
    },
    relatedStoreProductsDesktop: {
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        visibility: "hidden",
        display:'none'
      },
    },
    FromSameStoreHeadingBoxDesktop: {
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        visibility: "hidden",
        display: "none",
      },
      visibility: "block",
      borderBottom: "0.2px solid #e9e9e9",
      padding: 20,
      paddingLeft: 26,
      backgroundColor: "#fff",
    },

    //Related products section
    dealsBox: {
      marginTop: theme.spacing(4),
    },
    dealsBoxMobile:{
      marginTop:30,
      [theme.breakpoints.up(myTheme.breakpoints.values.sm)]: {
        visibility: "hidden",
        display:'none'
      },
    },
    DealsHeaderTextBox: {
      display: "flex",
      [theme.breakpoints.down(600)]: {
        flexDirection: "column",
      },
    },
    dealsOfDayText: {
      [theme.breakpoints.down(572)]: {
        fontSize: 25,
      },
    },
    timerText: {
      color: myTheme.palette.primary.main,
      [theme.breakpoints.down(572)]: {
        fontSize: 25,
      },
      [theme.breakpoints.down(500)]: {
        marginTop: 10,
      },
    },
    DealProductsCardsScrollBox: {
      overflow: "auto",
      "overflow-x": "scroll",
      display: "flex",
      animation: "7s delay-overflow",
    },
    navDealProductsBtnBox: {
      margin: "auto",
      position: "sticky",
      marginRight: 0,
    },
    addReviewBtn: {
      marginTop: 20,
      backgroundColor: myTheme.palette.primary.main,
      color: "white",
      "&:hover": {
        backgroundColor: myTheme.palette.primary.dark,
        color: myTheme.palette.primary.contrastText,
      },
      modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      //form
      root: {
        padding: 30,
        display:'flex',
        justifyContent:'center'
      },
      mainGrid: {
        margin: "auto",
        justifyContent: "center",
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
          width: 600,
          marginLeft: "auto",
          marginRight: "auto",
        },
        marginTop: 175,
        [theme.breakpoints.down(myTheme.breakpoints.values.xmd)]: {
          marginTop: 164,
        },
        [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
          marginTop: 160,
        },
      },
      paper: {
        margin: theme.spacing(7, 4),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      avatar: {
        margin: theme.spacing(1),
        backgroundColor: myTheme.palette.primary.main,
      },
      ReviewModalForm:{
        width: "100%",
            maxWidth: "100vw",
            maxHeight: "100%",
            position: "fixed",
            top: "10%",
            left: "30%",
            [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
              // left:'5%',
              // top:'20%',
              // maxWidth: "90vw",
              // width:'90%'
            },
      },
      form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(3),
        padding: 20,
        display: "flex",
        flexDirection: "column",
      },
      submit: {
        margin: theme.spacing(3, 0, 2),
      },
    },
  };
});

export default useStyles;
